<dcr-tree (tree-selection-change)="onSelectionChange($event)">
  @for (item of treeItems; track trackByFn($index, item)) {
    <dcr-tree-item
      [label]="item.label"
      [icon]="item.icon"
      [attr.id]="treePrefix + item.id"
      [hasBadge]="item.hasBadge"
      [selected]="!!item.selected"
      [expanded]="!!item.expanded"
    >
      <div slot="trailing-actions">
        @if (itemTrailingActionsTemplate) {
          <ng-container *ngTemplateOutlet="itemTrailingActionsTemplate; context: { $implicit: item }"></ng-container>
        }
        @if (trailingActionsTemplate) {
          <ng-container *ngTemplateOutlet="trailingActionsTemplate; context: { $implicit: item }"></ng-container>
        }
      </div>
      <ng-container *ngTemplateOutlet="treeItemContent; context: { $implicit: item.children }"></ng-container>
    </dcr-tree-item>
  }

  <ng-template #treeItemContent let-items>
    @for (child of items; track trackByFn($index, child)) {
      <dcr-tree-item
        [attr.id]="treePrefix + child.id"
        [label]="child.label"
        [icon]="child.icon"
        [hasBadge]="child.hasBadge"
        [selected]="!!child.selected"
        [expanded]="!!child.expanded"
      >
        <div slot="trailing-actions">
          @if (itemTrailingActionsTemplate) {
            <ng-container *ngTemplateOutlet="itemTrailingActionsTemplate; context: { $implicit: child }"></ng-container>
          }
          @if (trailingActionsTemplate) {
            <ng-container *ngTemplateOutlet="trailingActionsTemplate; context: { $implicit: child }"></ng-container>
          }
        </div>
        @if (child.children?.length) {
          <ng-container *ngTemplateOutlet="treeItemContent; context: { $implicit: child.children }"></ng-container>
        }
      </dcr-tree-item>
    }
  </ng-template>
</dcr-tree>
